var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-bin-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6667 8.50002H29.3333V11.1667H26.6667V28.5C26.6667 29.2364 26.0697 29.8334 25.3333 29.8334H6.66667C5.93029 29.8334 5.33333 29.2364 5.33333 28.5V11.1667H2.66667V8.50002H9.33333V4.50002C9.33333 3.76365 9.93029 3.16669 10.6667 3.16669H21.3333C22.0697 3.16669 22.6667 3.76365 22.6667 4.50002V8.50002ZM12 15.1667V23.1667H14.6667V15.1667H12ZM17.3333 15.1667V23.1667H20V15.1667H17.3333ZM12 5.83335V8.50002H20V5.83335H12Z",
    fill: "#D0D5DD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBinFill);
export default __webpack_public_path__ + "static/media/delete-bin-fill.ed93502462c428f8fd71c139c154798e.svg";
export { ForwardRef as ReactComponent };